import type { Fuel } from '@cobliteam/common-types';
import type { APIFuel, APISize } from './Types';

const IFuelToAPIFuelMap: Map<string, APIFuel> = new Map();
IFuelToAPIFuelMap.set('Gasolina', 'gas');
IFuelToAPIFuelMap.set('Etanol', 'ethanol');
IFuelToAPIFuelMap.set('GNV', 'cng');
IFuelToAPIFuelMap.set('Diesel', 'diesel');

const vehicleSizeToAPISizeMap: Map<string, APISize> = new Map();
vehicleSizeToAPISizeMap.set('Pequeno', 'small');
vehicleSizeToAPISizeMap.set('Médio', 'medium');
vehicleSizeToAPISizeMap.set('Grande', 'big');

const fuelAPIToIFuelMap: Map<APIFuel, string> = new Map();
fuelAPIToIFuelMap.set('gas', 'Gasolina');
fuelAPIToIFuelMap.set('ethanol', 'Etanol');
fuelAPIToIFuelMap.set('cng', 'GNV');
fuelAPIToIFuelMap.set('diesel', 'Diesel');

const sizeAPIToISizeMap: Map<APISize, string> = new Map();
sizeAPIToISizeMap.set('small', 'Pequeno');
sizeAPIToISizeMap.set('medium', 'Médio');
sizeAPIToISizeMap.set('big', 'Grande');

export const IFuelToAPIFuel = (fuel: Fuel): string | undefined => IFuelToAPIFuelMap.get(fuel.type || '');

export const vehicleSizeToAPISize = (size: string): APISize | undefined => vehicleSizeToAPISizeMap.get(size);

export const fuelTypeAPItoIFuelType = (fuelType: APIFuel): string | undefined => fuelAPIToIFuelMap.get(fuelType);

export const vehicleSizeAPIToISize = (size: APISize): string | undefined => sizeAPIToISizeMap.get(size);
